import { AlignmentType, Document, Packer, Paragraph, TextRun } from 'docx';

// Dilekçe belgesi (DOCX). Türkçe resmi biçim; içerik değişmedi.

const TR_MONTHS = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

/** "9 Ekim 2026" (belgede ve kayıtta Türkçe). */
export const formatTurkishDate = (date) => {
  const d = new Date(date);
  return `${d.getDate()} ${TR_MONTHS[d.getMonth()]} ${d.getFullYear()}`;
};

/** Dilekçe numarası: DLK-yyyymmdd-rrrr */
export const generateDocumentNumber = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const random = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
  return `DLK-${year}${month}${day}-${random}`;
};

const line = (text, options = {}, paragraph = {}) => new Paragraph({
  children: [new TextRun({ text, size: 22, ...options })],
  ...paragraph,
});

export const generateDilekceDocument = async (data) => {
  const document = new Document({
    sections: [{
      properties: {},
      children: [
        line('HabcareCRO', { bold: true, size: 28 }, { alignment: AlignmentType.CENTER, spacing: { after: 200 } }),
        line(`Tarih: ${data.formattedDate}`, {}, { alignment: AlignmentType.RIGHT, spacing: { after: 200 } }),
        line(`Dilekçe No: ${data.documentNumber}`, { italics: true }, { alignment: AlignmentType.RIGHT, spacing: { after: 400 } }),
        line('DİLEKÇE', { bold: true, size: 36 }, { alignment: AlignmentType.CENTER, spacing: { after: 100 } }),
        line(data.typeLabel, { size: 24, italics: true }, { alignment: AlignmentType.CENTER, spacing: { after: 400 } }),
        line('MUHATAP:', { bold: true }, { spacing: { after: 100 } }),
        line(data.targetNames.join(', '), {}, { spacing: { after: 300 } }),
        line('BAŞVURU SAHİBİ BİLGİLERİ:', { bold: true }, { spacing: { after: 100 } }),
        line(`Ad Soyad: ${data.employeeName}`, {}, { spacing: { after: 50 } }),
        line(`E-posta: ${data.employeeEmail}`, {}, { spacing: { after: 50 } }),
        ...(data.employeeTitle ? [line(`Unvan: ${data.employeeTitle}`, {}, { spacing: { after: 50 } })] : []),
        ...(data.employeeDepartment ? [line(`Departman: ${data.employeeDepartment}`, {}, { spacing: { after: 50 } })] : []),
        new Paragraph({ children: [new TextRun({ text: '' })], spacing: { after: 200 } }),
        new Paragraph({
          children: [
            new TextRun({ text: 'KONU: ', bold: true, size: 22 }),
            new TextRun({ text: data.subject, size: 22 }),
          ],
          spacing: { after: 300 },
        }),
        line('Sayın İlgili,', { italics: true }, { spacing: { after: 200 } }),
        line(data.details, {}, { spacing: { after: 300 } }),
        line('Gereğini bilgilerinize arz ederim.', { italics: true }, { alignment: AlignmentType.RIGHT, spacing: { after: 100 } }),
        line('Saygılarımla,', { italics: true }, { alignment: AlignmentType.RIGHT, spacing: { after: 200 } }),
        line(data.employeeName, { bold: true, size: 24 }, { alignment: AlignmentType.RIGHT, spacing: { after: 100 } }),
        line(data.formattedDate, { size: 20 }, { alignment: AlignmentType.RIGHT }),
      ],
    }],
  });

  return Packer.toBlob(document);
};
